var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3109 4.62532L15.9763 4.6257L16.0515 4.63612L16.1256 4.65682L16.1708 4.67602C16.2302 4.7022 16.2859 4.74015 16.3348 4.78912L16.3654 4.82212L16.398 4.86442L16.4386 4.932L16.4677 4.99972L16.482 5.0478L16.4922 5.0958L16.4992 5.16645L16.4996 10.8157C16.4996 11.1264 16.2478 11.3782 15.9371 11.3782C15.6523 11.3782 15.417 11.1666 15.3797 10.8921L15.3746 10.8157L15.3742 6.54457L9.58515 12.3348C9.38542 12.5345 9.07297 12.5526 8.8527 12.3892L8.78962 12.3348L6.56177 10.107L2.45951 14.2093C2.23984 14.4289 1.88369 14.4289 1.66402 14.2093C1.46432 14.0096 1.44616 13.6971 1.60956 13.4769L1.66402 13.4138L6.16402 8.91375C6.36372 8.7141 6.67621 8.69595 6.89641 8.8593L6.9595 8.91375L9.18735 11.1415L14.5777 5.75032H10.3109C10.0261 5.75032 9.79087 5.53867 9.7536 5.26417L9.74842 5.18782C9.74842 4.90305 9.96007 4.6677 10.2346 4.63042L10.3109 4.62532Z",
    fill: "#16C265"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendingUp);
export default __webpack_public_path__ + "static/media/arrow-trending-up.917994d31967c1ecfb645f2f507f0028.svg";
export { ForwardRef as ReactComponent };